"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildParser = void 0;
var sanitize_html_1 = __importDefault(require("sanitize-html"));
var CUSTOM_TAG = {
    HEAD: '[[',
    TAIL: ']]',
    CLOSE_SYMBOL: '/',
};
var startTag = function (tagName) { return CUSTOM_TAG.HEAD + tagName + CUSTOM_TAG.TAIL; };
var endTag = function (tagName) { return CUSTOM_TAG.HEAD + CUSTOM_TAG.CLOSE_SYMBOL + tagName + CUSTOM_TAG.TAIL; };
var buildCustomTags = function (parseDefs) { return parseDefs.reduce(function (obj, _a) {
    var _b;
    var tagName = _a.tagName;
    return (__assign(__assign({}, obj), (_b = {}, _b[tagName] = {
        start: startTag(tagName),
        end: endTag(tagName)
    }, _b)));
}, {}); };
var buildHtmlTag = function (tagDef) { return ({
    start: "<".concat(tagDef.name, " ").concat(Object.entries(tagDef.attributes || {}).map((function (_a) {
        var k = _a[0], v = _a[1];
        return "".concat(k, "=\"").concat(v, "\"");
    })).join(" "), ">"),
    end: "</".concat(tagDef.name, ">")
}); };
var escape = function (text) { return (text.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')); };
var sanitize = function (text) { return (0, sanitize_html_1.default)(text, {
    // TODO: 許可するタグを決める
    disallowedTagsMode: 'escape'
}); };
var parseRawHtml = function (parseDefs, customTags) { return function (rawBody) { return (parseDefs.reduce(function (text, parseDef) {
    var customTag = customTags[parseDef.tagName];
    var htmlTag = buildHtmlTag(parseDef.mappedTag);
    return text.replace(
    // NOTE: sフラグはブラウザによってエラーになるのでつかわない
    new RegExp("".concat(escape(customTag.start), "((.|\\s)*?)").concat(escape(customTag.end)), 'g'), "".concat(htmlTag.start, "$1").concat(htmlTag.end));
}, sanitize(rawBody))); }; };
var buildParser = function (parseDefs) {
    var customTags = buildCustomTags(parseDefs);
    return { customTags: customTags, parse: parseRawHtml(parseDefs, customTags) };
};
exports.buildParser = buildParser;
